// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2By0v","dragIcon":"SortableItem_dragIcon__3Ewyo","disabled":"SortableItem_disabled__3fEjA"};